import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { games } from "../data/games";
import GameCard from "../components/GameCard";
import { Link } from "react-router-dom";

function Profile() {
  const { user } = useContext(AuthContext);
  const  [userVotes, setUserVotes] = useState({});
  const [myComments, setMyComments] = useState([]);
const [notifications, setNotifications] = useState([]);

  // On récupère le prénom comme dans ton Header
  const displayFirstName = user?.name ? user.name.split(' ')[0] : "Joueur";

  useEffect(() => {
    if (user?.name) {
    const notifs = JSON.parse(localStorage.getItem(`notifications_${user.name}`) || "[]");
    setNotifications(notifs.reverse()); // Les plus récentes en premier

    // Une fois que l'utilisateur a vu son profil, on marque tout comme lu
    const updatedNotifs = notifs.map(n => ({ ...n, read: true }));
    localStorage.setItem(`notifications_${user.name}`, JSON.stringify(updatedNotifs));
  }
    // 1. Charger les notes
    const votes = JSON.parse(localStorage.getItem("gamePulseVotes") || "{}");
    setUserVotes(votes);

    // 2. Charger les commentaires en filtrant par user.name
    const allComments = [];
    if (user?.name) {
      games.forEach(game => {
        const gameReviews = JSON.parse(localStorage.getItem(`reviews_${game.id}`) || "[]");
        // On filtre par le nom complet stocké
        const userReviews = gameReviews.filter(rev => rev.username === user.name);
        if (userReviews.length > 0) {
          allComments.push({ gameTitle: game.title, id: game.id, comments: userReviews });
        }
      });
    }
    setMyComments(allComments);
  }, [user]);

  if (!user) return <div style={{color: "white", padding: "150px", textAlign: "center"}}><h2>Veuillez vous connecter.</h2></div>;

  return (
    <div style={{ backgroundColor: "#0b0b13", minHeight: "100vh", color: "white", padding: "120px 20px" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        
        {/* HEADER PROFIL - Aligné sur ton Nav */}
        <div style={{ display: "flex", alignItems: "center", gap: "25px", marginBottom: "50px", background: "#1a1b26", padding: "40px", borderRadius: "20px", border: "1px solid #333" }}>
          <img 
            src={user.avatar || "/logox.jpg"} 
            alt="avatar" 
            style={{ width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover", border: "3px solid #ec008c" }} 
          />
          <div>
            <h1 style={{ fontSize: "2.5rem", margin: 0 }}>Bonjour, {displayFirstName} !</h1>
            <p style={{ color: "#00ffcc", marginTop: "5px" }}>{user.name}</p>
          </div>
        </div>

        {/* SECTION FAVORIS */}
        {notifications.length > 0 && (
  <section style={{ marginBottom: "50px" }}>
    <h2 style={{ color: "#ffc107", marginBottom: "20px" }}>🔔 Notifications</h2>
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {notifications.map(n => (
        <div key={n.id} style={{ 
          background: n.read ? "#1a1b26" : "#252736", 
          padding: "15px", borderRadius: "10px", borderLeft: n.read ? "none" : "4px solid #ffc107" 
        }}>
          <p>
            <strong style={{ color: "#00ffcc" }}>{n.from}</strong> a répondu à votre commentaire sur le jeu 
            <Link to={`/game/${n.gameId}`} style={{ color: "#ec008c", textDecoration: "none" }}> {n.gameTitle}</Link>
          </p>
          <small style={{ opacity: 0.5 }}>{n.date}</small>
        </div>
      ))}
    </div>
  </section>
)}
        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ color: "#ec008c", marginBottom: "30px", fontSize: "1.8rem" }}>❤️ Mes Favoris</h2>
          {user.favorites && user.favorites.length > 0 ? (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "25px" }}>
              {user.favorites.map(fav => {
                const fullGame = games.find(g => g.id === fav.id);
                return <GameCard key={fav.id} game={fullGame || fav} />;
              })}
            </div>
          ) : (
            <p style={{ opacity: 0.5, background: "#1a1b26", padding: "20px", borderRadius: "10px" }}>Vous n'avez pas encore de favoris.</p>
          )}
        </section>

        {/* ACTIVITÉ RÉCENTE (COMMENTAIRES) */}
        <section>
          <h2 style={{ color: "#00ffcc", marginBottom: "30px", fontSize: "1.8rem" }}>💬 Mes avis publiés</h2>
          {myComments.length > 0 ? (
            myComments.map((item, idx) => (
              <div key={idx} style={{ background: "#1a1b26", padding: "25px", borderRadius: "15px", marginBottom: "20px", borderLeft: "4px solid #ec008c" }}>
                <Link to={`/game/${item.id}`} style={{ color: "#ec008c", textDecoration: "none", fontSize: "1.2rem", fontWeight: "bold" }}>{item.gameTitle}</Link>
                {item.comments.map((c, i) => (
                  <div key={i} style={{ marginTop: "15px", borderTop: "1px solid #333", paddingTop: "10px" }}>
                    <p style={{ opacity: 0.9, lineHeight: "1.5" }}>"{c.text}"</p>
                    <span style={{ fontSize: "0.8rem", opacity: 0.5 }}>Publié le {c.date}</span>
                  </div>
                ))}
              </div>
            ))
          ) : (
            <p style={{ opacity: 0.5 }}>Aucun commentaire publié pour le moment.</p>
          )}
        </section>
      </div>
    </div>
  );
}

export default Profile;